import React, { createContext, useContext, useState, useEffect } from 'react';
import { getSession, logout as doLogout, startLogin } from '../config/auth';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(() => getSession());
  const isLoggedIn = !!session;
  const user = session?.user || null;

  useEffect(() => {
    // Sync across tabs
    const handleStorage = (e) => {
      if (e.key === 'forge_session') {
        setSession(e.newValue ? JSON.parse(e.newValue) : null);
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const login = () => startLogin();

  const logout = () => {
    setSession(null);
    doLogout();
  };

  const updateSession = (newSession) => {
    setSession(newSession);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, session, login, logout, updateSession }}>
      {children}
    </AuthContext.Provider>
  );
};
